import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { map, catchError } from 'rxjs/operators';

import { Config } from '../config';
import {  IColumnHeader, IRelationshipMain, IRelationshipCodeLineItems } from '../models/relationship';
import { CommonService } from '../../shared/services/common.service';
import { IObjectStatus, IFiscalYear } from '../models/common';

@Injectable({
    providedIn: 'root'
})
export class RelationshipService {
    baseUrl: string = Config.ROOT_URL;
    CommonUrl = '/api/Common';
    RelationshipUrl = '/api/Relationship';
    constructor(private dataService: CommonService, private http: HttpClient) { }
    getFiscalYears(): Observable<IFiscalYear[]> {
        return this.http.get<IFiscalYear[]>(this.baseUrl + this.CommonUrl + '/GetFiscalYear', { headers: Config.httpHeaders })
            .pipe(
                map(results => {
                    return results;
                }),
                catchError(this.dataService.handleError)
            );

    }
    GetRelationshipColumns(): Observable<IColumnHeader[]> {
        // tslint:disable-next-line:max-line-length
        return this.http.get<IColumnHeader[]>(this.baseUrl + this.RelationshipUrl + '/GetRelationshipColumns', { headers: Config.httpHeaders })
            .pipe(
                map(results => {
                    return results;
                }),
                catchError(this.dataService.handleError)
            );
    }

    // tslint:disable-next-line:max-line-length
    getMainMappingCodes(fiscalYearConfigID: number, columnHeaderID: number, checkPublish: boolean): Observable<IRelationshipCodeLineItems[]> {
        // tslint:disable-next-line:max-line-length
        return this.http.get<IRelationshipCodeLineItems[]>(this.baseUrl + this.RelationshipUrl + '/getMainMappingCodes' + '/' + fiscalYearConfigID + '/' + columnHeaderID + '/' + checkPublish, { headers: Config.httpHeaders })
            .pipe(
                map(results => {
                    return results;
                }),
                catchError(this.dataService.handleError)
            );
    }

    getMappingDetailsCodes(fiscalYearConfigID: number, ColumnHeaderID: number, CodeID: number): Observable<IRelationshipMain[]> {
        // tslint:disable-next-line:max-line-length
        return this.http.get<IRelationshipMain[]>(this.baseUrl + this.RelationshipUrl + '/getMappingRelatedCodes' + '/' + fiscalYearConfigID + '/' + ColumnHeaderID + '/' + CodeID, { headers: Config.httpHeaders })
            .pipe(
                map(results => {
                    return results;
                }),
                catchError(this.dataService.handleError)
            );
    }

    getAvailableMappingCodes(fiscalYearConfigID: number, ColumnHeaderID: number, CodeID: number): Observable<IRelationshipMain[]> {
        // tslint:disable-next-line:max-line-length
        return this.http.get<IRelationshipMain[]>(this.baseUrl + this.RelationshipUrl + '/GetAvailableMapping' + '/' + fiscalYearConfigID + '/' + ColumnHeaderID + '/' + CodeID, { headers: Config.httpHeaders })
            .pipe(
                map(results => {
                    return results;
                }),
                catchError(this.dataService.handleError)
            );
    }

    // updateExcludeMapping(excmap: IRelationshipMain[]): Observable<string> {
    updateAvailableMapping(availablemap: any, updatedBy: number): Observable<string> {
        // tslint:disable-next-line:max-line-length
        return this.http.post<string>(this.baseUrl + this.RelationshipUrl + '/updateAvailableMapping/' + updatedBy, availablemap, { headers: Config.httpHeaders })
            .pipe(
                map(results => {
                    return results;
                }),
                catchError(this.dataService.handleError)
            );
    }

    Publish(mappingList: IRelationshipMain[], updatedBy: number, fiscalYear: number): Observable<IObjectStatus[]> {
        // tslint:disable-next-line:max-line-length
        return this.http.post<IObjectStatus[]>(this.baseUrl + this.RelationshipUrl +
            '/Publish/' + fiscalYear + '/' + updatedBy, mappingList, { headers: Config.httpHeaders })
            .pipe(
                map(results => {
                    return results;
                }),
                catchError(this.dataService.handleError)
            );
    }

}
